
<template>
    <div id="google-map-markers"></div>
</template>


<script>
    export default {

        props: {
            map: {required: false}
        },

        data() {
            return{
                markers: [],
                icons: {},
            }
        },

        mounted: function () {
            bus.$on('map-initialized', ( google ) => {
                this.initializeAllIcons( google );
                this.initializeMarkers();
            });
        },

        methods: {
            initializeMarkers: function () {

                this.newMarker( this.$parent.center, this.icons['center'].icon );

                bus.$on('marker-place-add', ( place ) => {
                    this.newMarker( place, this.icons[place.type].icon );
                });

                bus.$on('marker-place-remove', ( place ) => {
                    this.removeMarker( place, this.icons[place.type].icon );
                });

                bus.$on( 'marker-place-toggle', ( place, selected ) => {
                    if ( selected ) {
                        _.forEach( this.markers, ( marker ) => {
                            let icon = marker.getIcon();
                            icon.url = icon.url.replace( '-active', '' );
                            marker.setIcon( icon );
                            marker.setZIndex( null );
                        });

                        let markerIndex = this.findMarkerIndex( place );
                        if ( markerIndex !== -1 ) {
                            this.markers[markerIndex].setIcon( this.icons[place.type].active );
                            this.markers[markerIndex].setZIndex( 1000 );
                        }
                    } else {
                        let markerIndex = this.findMarkerIndex( place );
                        if ( markerIndex !== -1 ) {
                            this.markers[markerIndex].setIcon( this.icons[place.type].icon );
                        }
                    }
                });
            },

            findMarkerIndex: function ( position ) {
                return _.findIndex( this.markers, function( marker ) {
                    return marker.placeId === (position.lat + position.lng);
                });
            },

            newMarker: function ( position, icon ) {
                let marker = new google.maps.Marker({
                    map: this.$parent.map,
                    icon: icon,
                    position: { lat: parseFloat( position.lat ), lng: parseFloat( position.lng ) },
                    placeId: position.lat + position.lng,
                });
                this.markers.push( marker );
                this.fitBounds();
                return marker;
            },

            removeMarker: function ( position, icon ) {
                let markerIndex = this.findMarkerIndex( position );

                if ( markerIndex === -1 ) return;

                this.markers[markerIndex].setMap( null );
                this.markers.splice( markerIndex, 1 );
            },

            fitBounds: function () {
                let bounds = new google.maps.LatLngBounds();

                _.forEach( this.markers, function ( marker ) {
                    bounds.extend( marker.getPosition() );
                });
                this.$parent.map.fitBounds( bounds );
                this.$parent.map.setZoom(16.8);
            },

            initializeAllIcons: function ( google ) {
                this.icons = {
                    center: {
                        icon: {
                            url: '/images/map/notaria.png',
                        },
                    },
                    parking: {
                        icon: {
                            url: '/images/map/parking.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                        active: {
                            url: '/images/map/parking-active.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                    },
                    bus: {
                        icon: {
                            url: '/images/map/bus.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                        active: {
                            url: '/images/map/bus-active.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                    },
                    cercanias: {
                        icon: {
                            url: '/images/map/cercanias.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                        active: {
                            url: '/images/map/cercanias-active.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                    },
                    metro: {
                        icon: {
                            url: '/images/map/metro.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                        active: {
                            url: '/images/map/metro-active.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                    },
                    renfe: {
                        icon: {
                            url: '/images/map/renfe.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                        active: {
                            url: '/images/map/renfe-active.png',
                            scaledSize: new google.maps.Size( 30, 30 ),
                        },
                    },
                };
            }
        }
    }

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/GoogleMapMarkers.vue